// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import * as firebase from 'firebase'
import store from './store/'
import router from './router'
import Alert from './components/shared/Alert.vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'
import './styles/main.css' // custom global css rules

Vue.config.productionTip = false
Vue.component('app-alert', Alert)
Vue.use(Vuetify, {
  theme: {
    primary: '#f7a700',
    secondary: '#BA792A', //
    accent: '#003b70', //
    error: '#cc0000', //
    info: '#005f9b', //
    success: '#00997C', //
    warning: '#deb853' //
  }
})
// Bind the document title to page names
router.beforeEach((to, from, next) => {
  document.title = to.name
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyByPYUX_g6JPPeljJTxjoOLGDZheE6MnB0',
      authDomain: 'sunpeak-web-forms.firebaseapp.com',
      databaseURL: 'https://sunpeak-web-forms.firebaseio.com',
      projectId: 'sunpeak-web-forms',
      storageBucket: 'sunpeak-web-forms.appspot.com'
    })
    // Track core authentication state here
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.commit('updateUser', {
          id: user.uid,
          email: user.email,
          emailVerified: user.emailVerified
        })
        this.$store.dispatch('user/fetchState', user.uid)
      } else {
        this.$store.commit('unsetUser', {})
        this.$router.push('/signin')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js